import { TGiftPackType } from '../../../entities/giftPackages/queries';
import { TGiftPackageType, TProduct } from '../../../generated/graphql';

type TGetPackageProductsProps = {
  type: TGiftPackageType;
  subType?: string;
  activated?: boolean | null;
  defaultPackages?: null | TGiftPackType[];
  giftPacks?: null | TGiftPackType[];
};

export const getPackageProducts = ({ type, subType, activated, defaultPackages, giftPacks }: TGetPackageProductsProps) => {
  const defaultProducts = (defaultPackages?.find((pack) => pack.type == type && (subType === undefined || pack.subType == subType))?.hydratedProducts as unknown as TProduct[]) || [];

  const overrideProducts = (giftPacks?.find((pack) => pack.type == type && (subType === undefined || pack.subType == subType))?.hydratedProducts as unknown as TProduct[]) || [];

  const hasOverride = Boolean(activated) && overrideProducts.length > 0;

  return hasOverride ? overrideProducts : defaultProducts;
};
